import { HeartRate } from "@cur8/health-risks-calc";
import { useQueryParams } from "@pomle/react-router-paths";
import { withDecimals } from "lib/math";
import { useHasAttendedVisitInSweden } from "render/hooks/api/queries/useVisitsQuery";
import { queries } from "render/routes/paths";
import { toChartRanges } from "render/ui/presentation/RangeChart/lib/risk";
import { MetricDetails } from "render/views/Report/AppointmentDataView/components/MetricsSection/components/layouts/Details";
import { getMetricHistory } from "render/views/Report/AppointmentDataView/components/MetricsSection/components/metrics/utils/getMetricHistory";
import { useHeartRateMetric } from "render/views/Report/AppointmentDataView/components/MetricsSection/hooks/usePatientReportMetrics";
import { Trans } from "./trans";

export function MetricHeartRateDetails() {
  const { data } = useHeartRateMetric();
  const { data: hasAttendedVisitInSweden } = useHasAttendedVisitInSweden();

  const [params, setParams] = useQueryParams(queries.metric);
  const numOfScans = data?.length || 1;
  const scanNum = params.scan[0] || numOfScans;
  const setScanNum = (num: number) =>
    setParams({
      scan: [num],
    });

  if (!data) {
    return undefined;
  }

  const { cur: current, prev: previous } = getMetricHistory(data, scanNum);

  const riskRanges = HeartRate.rangesFor();

  const values = {
    subLabel: "bpm",
    value: current && withDecimals(current.unit["bpm"], 0),
    previousValue: previous?.unit["bpm"]
      ? withDecimals(previous?.unit["bpm"], 0)
      : undefined,
    metricRating: current && riskRanges.findRisk(current.unit),
    scanDate: current?.measurement.timestampStart,
    ranges: toChartRanges(riskRanges.entries),
  };

  const isClinicalStudy = hasAttendedVisitInSweden === true;

  return (
    <MetricDetails
      label={<Trans.MetricName />}
      values={values}
      scanNum={scanNum}
      setScanNum={setScanNum}
      numOfScans={numOfScans}
      FAQText={Trans.FAQ}
      isClinicalStudy={isClinicalStudy}
      hideChange
    />
  );
}
